import {Component, DestroyRef, inject, OnInit} from '@angular/core';
import {consumerTypesFilterFieldMap as fieldMap} from '@emm/shared/formly/maps/consumer-types-filter.config';
import {filter, map, take} from 'rxjs/operators';
import {BehaviorSubject, finalize} from 'rxjs';
import {MatDialog} from '@angular/material/dialog';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {AuthFacadeService} from '@emm/auth/services/auth-facade.service';
import {defaultContextMenuAction} from '@emm/core/models/context-menu-action.model';
import {ConsumerTypesFacadeService} from '@emm/management/services/consumer-types-facade.service';
import {NotificationService} from '@emm/shared/services/notification.service';
import {
    AddConsumerTypeDialogComponent
} from '@emm/shared/dialogs/add-consumer-type-dialog/add-consumer-type-dialog.component';
import {SearchFilter} from '@emm/core/models/search-filter';
import {ConsumerType} from '@emm/core/models/consumer-type.model';
import {UserService} from '@emm/core/services/user.service';

@Component({
    selector: 'emm-consumer-types',
    styleUrls: ['./consumer-types.component.scss'],
    templateUrl: './consumer-types.component.html'
})
export class ConsumerTypesComponent implements OnInit {
    private readonly destroyRef: DestroyRef = inject(DestroyRef);
    centerLoading$ = this.consumerTypesFacade.centerLoading$;
    consumerTypes$ = new BehaviorSubject<any>(undefined);
    consumerTypesAsGenericItems$ = this.consumerTypesFacade.consumerTypesAsGenericItems$;
    consumerTypesContextMenuActions = defaultContextMenuAction;
    fields = [fieldMap['name'](), fieldMap['tag']()];
    isReadOnly$ = this.authFacade.isReadOnly$;
    isReadOnly = this.userService.hasLoginRole();
    isSuperAdmin = this.userService.hasSuperAdminRole();
    isAdmin = this.userService.hasAdminRole();
    isAuthor = this.userService.hasAuthorRole();
    selectedConsumerType$ = this.consumerTypesFacade.selectedConsumerType$;
    consumerTypesCache = [];
    anyLoading$ = this.consumerTypesFacade.anyLoading$;

    constructor(
        private authFacade: AuthFacadeService,
        private consumerTypesFacade: ConsumerTypesFacadeService,
        private dialog: MatDialog,
        private notificationService: NotificationService,
        private userService: UserService,
    ) {
    }


    ngOnInit(): void {
        this.consumerTypesFacade.init();
        this.anyLoading$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe();
        this.getConsumerTypes();
    }


    getConsumerTypes() {
        this.consumerTypesFacade.startProgressBar();
        this.consumerTypesAsGenericItems$
            .pipe(
                finalize(() => this.consumerTypesFacade.stopProgressBar()),
                takeUntilDestroyed(this.destroyRef))
            .subscribe(result => {
            this.consumerTypesCache = result;
            this.consumerTypes$.next(this.consumerTypesCache);
        });
    }

    openCreateConsumerTypeDialog(): void {
        const dialogRef = this.dialog.open(AddConsumerTypeDialogComponent, {
            width: '600px',
            data: {showDelete: false}
        });

        dialogRef.afterClosed()
            .pipe(
                filter((result) => result && result === 'submit'),
                takeUntilDestroyed(this.destroyRef))
            .subscribe(() => {
            this.notificationService.success('Added Successfully');
            this.getConsumerTypes();
        });
    }


    onFilter(searchFilter: SearchFilter): void {
        this.filterNodes(searchFilter.value as string, searchFilter.key);
    }


    filterNodes(value: string, selected: string): void {
        this.consumerTypes$.next(this.consumerTypesCache);
        this.consumerTypes$.pipe(
            take(1),
            map(list => {
                let filteredNodes;
                try {
                    switch (selected) {
                        case selected:
                            filteredNodes = list.filter(nd =>
                                nd['source'][selected].toLowerCase().includes(value.toLowerCase()));
                            break;
                        default:
                            filteredNodes = list.filter(nd => nd['name'].toLowerCase().includes(value.toLowerCase()));
                            break;
                    }
                    this.consumerTypes$.next(filteredNodes);
                } catch (e) {}
            }),
            takeUntilDestroyed(this.destroyRef)

        ).subscribe();
    }


    onSelectConsumerType(selected: ConsumerType): void {
        this.consumerTypesFacade.selectConsumerType(selected);
    }


}
